import React from "react";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface UnclaimButtonProps {
  langBase: string;
  permission: string | string[];
  isActionAvailable: boolean;
  onUnclaim: () => void;
}

const UnclaimButton: React.FC<UnclaimButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onUnclaim,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="unclaim-button"
      testId="unclaim"
      variant="outlined"
      onClick={onUnclaim}
    />
  );
};
export default UnclaimButton;
